<template>
  <div>
    <right-panel class="float-right" id="sidebar-new-unit" width="900px" :icon="'mdi mdi-plus'" :text="$t('unit.new')" @hidden="rightPanelClosed">
      <div class="pl-5 pr-5">
        <Form />
      </div>
    </right-panel>

    <!-- <div>
      <router-link to="/unit-graph">{{ $t("unit.graph") }}</router-link>
    </div> -->

    <div class="mb-5 mt-3">
      <h2 v-if="selectedEntity">
        <u class="dashed">{{ selectedEntity.name | translate }}</u>
        {{ $t("unit.subunits-of-the-unit") }}
      </h2>
      <h2 v-else>{{ $t("unit.organizational-units") }}</h2>
    </div>

    <div v-if="breadCrumb" class="mb-3 mt-3 breadcrumb">
      <span v-for="item in breadCrumb" :key="'bread_crumb' + item._id" class="breadcrumb-item">
        <router-link v-if="!item.first" :to="`/unit/${item._id}`">
          {{ item.name | translate }}
        </router-link>
        <router-link v-else :to="`/organization/unit-hierarchy`">
          {{ item.name }}
        </router-link>
      </span>
    </div>

    <content-loading v-if="isLoading" />

    <div v-if="pagination" class="row mt-4">
      <div v-for="item in pagination.docs" :key="item._id" class="col-xl-3 col-sm-6 d-flex">
        <div class="card flex-fill hider">
          <div class="card-body p-2">
            <h6 class="hand" @click="$router.push(`/unit/${item._id}`)">
              <i class="bx bxs-school mr-1 mt-2"></i>
              {{ item.name | translate }}
            </h6>

            <div v-if="item.parent" class="text-muted">
              <b>{{ $t("unit.parent") }}: </b>
              {{ item.parent.name | translate }}
            </div>
            <div class="font-size-16 hidden float-right">
              <i class="bx bx-trash-alt text-danger hand mr-3" v-b-tooltip.hover :title="$t('common.delete')" @click="deleteById(item)"></i>
              <i class="bx bx-pencil text-primary hand" v-b-tooltip.hover :title="$t('common.edit')" @click="edit(item)"></i>
            </div>
          </div>
        </div>
      </div>

      <br style="clear: both" />
    </div>

    <!-- Begin: Pagination -->

    <div v-if="pagination" class="row">
      <div class="col">
        <ul class="pagination pagination-rounded mb-0">
          <b-pagination v-model="request.options.page" :total-rows="pagination.totalDocs" :per-page="pagination.limit" limit="10" size="sm"></b-pagination>
        </ul>
      </div>
    </div>
    <!-- End: Pagination -->
  </div>
</template>

<script>
import Form from "./organization-unit-form";

export default {
  components: { Form },
  data() {
    return {
      request: {
        options: { page: 1, limit: 16 },
      },
    };
  },
  computed: {
    breadCrumb() {
      let el = this.selectedEntity;
      if (!el) {
        return null;
      }
      const arr = [el];
      while (el?.parent) {
        arr.unshift(el.parent);
        el = el.parent;
      }
      const org = {
        ...this.$store.getters["organization/selected"],
        first: true,
      };
      arr.unshift(org);
      return arr;
    },
    selectedEntity() {
      return this.$store.getters["organizationUnit/selectedEntity"];
    },
    pagination() {
      return this.$store.getters["organizationUnit/pagination"];
    },
    isLoading() {
      return this.$store.getters["organizationUnit/isLoading"];
    },
  },
  watch: {
    request: {
      deep: true,
      handler() {
        this.debounceMixin(() => this.paginate());
      },
    },
    "$route.params.id": {
      async handler() {
        this.init();
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {},
  methods: {
    async init() {
      const id = this.$route.params.id;
      if (id) {
        this.request.query = {
          parent: { value: id, isObject: true },
        };
        await this.findById(id);
      } else {
        await this.$store.dispatch("organizationUnit/clearSelectedEntity");
        this.request.query = { parent: { value: null, isObject: true } }; //just root unit
      }
      await this.paginate();
    },

    async paginate() {
      await this.$store.dispatch("organizationUnit/paginate", this.request);
    },

    async findById(id) {
      await this.$store.dispatch("organizationUnit/findById", id);
    },

    async deleteById(item) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch("organizationUnit/delete", item._id);
        this.init();

        this.$toast.success("'" + this.$options.filters.translate(item.name) + "' Silindi");
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error, { customMessage: "'" + this.$options.filters.translate(item.name) + "' Silinemedi" });
      }
    },

    edit(item) {
      this.$store.commit("organizationUnit/editedEntity", item);
      this.$root.$emit("bv::toggle::collapse", "sidebar-new-unit");
    },

    rightPanelClosed() {
      this.paginate();
      this.$store.commit("organizationUnit/editedEntity", null);
    },
  },
};
</script>
